import { IntegrationStatus } from '../../shared/interfaces/integration';

const completedStatus = [
  IntegrationStatus.CONFIGURED_OBJECT,
  IntegrationStatus.INITIALIZED,
  IntegrationStatus.INITIALIZE_FAILED,
  IntegrationStatus.INITIALIZING,
  IntegrationStatus.PAUSED,
  IntegrationStatus.STREAMING,
  IntegrationStatus.DISABLING,
  IntegrationStatus.DISABLED,
  IntegrationStatus.ENABLING,
  IntegrationStatus.DISABLE_FAILED,
  IntegrationStatus.DELETE_FAILED,
  IntegrationStatus.SYNC_TASK_FLOW_FAILED,
  IntegrationStatus.ENABLE_FAILED,
  IntegrationStatus.RESTARTING,
  IntegrationStatus.RESTART_FAILED
];

export function shouldResumePipelineCreate(status: IntegrationStatus) {
  return !completedStatus.includes(status);
}

export function isEditingPipeline(status: IntegrationStatus) {
  return completedStatus.includes(status);
}
